module.exports = __webpack_public_path__ + "img/gongsi.43bcac9d.png";